export default {
  title: "403 Forbidden",
  description:
    "Sorry, you don't have permission to access this page. Please contact your administrator if you believe this is an error.",
  goHome: "Go to Homepage",
  goBack: "Go Back",
};
